let openPopup = null;

export function registerPopup(fn) {
  openPopup = fn;
}

export function abrirPopup(titulo, contenido) {
  if (openPopup) {
    openPopup({ titulo, contenido });
  }
}
